import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// MY PROFILE
export const UserAccountPage = Loadable(lazy(() => import('../pages/dashboard/UserAccountPage')));
export const InvoiceListPage = Loadable(lazy(() => import('../pages/dashboard/InvoiceListPage')));
export const OrderDetails = Loadable(lazy(() => import('../pages/dashboard/OrderDetails')));

// MAIN
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
export const FaqsPage = Loadable(lazy(() => import('../pages/FaqsPage')));
export const AboutPage = Loadable(lazy(() => import('../pages/AboutPage')));
export const BenefitPage = Loadable(lazy(() => import('../pages/BenefitPage')));
export const FuncionalityPage = Loadable(lazy(() => import('../pages/FuncionalityPage')));
export const AgrolabStamp = Loadable(lazy(() => import('../pages/AgrolabStamp')));
export const Contact = Loadable(lazy(() => import('../pages/ContactPage')));
export const PricingPage = Loadable(lazy(() => import('../pages/PricingPage')));
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')));
export const ComingSoonPage = Loadable(lazy(() => import('../pages/ComingSoonPage')));

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));
export const ResendCode = Loadable(lazy(() => import('../pages/auth/RessendCode')));

// E-commerce
export const EcommerceAllShopPage = Loadable(lazy(() => import('../pages/e-commerce/EcommerceAllShopPage')));
export const EcommerceShopPage = Loadable(lazy(() => import('../pages/e-commerce/EcommerceShopPage')));
export const EcommerceProductDetailsPage = Loadable(lazy(() => import('../pages/e-commerce/EcommerceProductDetailsPage')));
export const EcommerceCheckoutPage = Loadable(lazy(() => import('../pages/e-commerce/EcommerceCheckoutPage')));